export class CandidateToken {

    tkcD_ID: any;
    tkcD_CANDIDATE_ID: string;
    tkcD_TOKEN: string;
    tkcD_DUE_DATE: Date;
    tkcD_ACTIVE: true;
    tkcD_CREATED_DATE: Date;
}